import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';
import Header from './header';
import Logo from './logo';
import Content from './content';
import BottomFooter from './bottomFooter';

const Layout = ({ content }) => {
    const { nav, logo, footer, recommend, newsstream, isEnd, columnId, recommendId, repeatedID, seo } = content;

    return (
        <div className={styles.layout}>
            <Header content={nav} />
            <header className={styles.pageHeader}>
                <Logo content={logo} />
            </header>
            <div className={styles.divider} />
            <main className={styles.main}>
                <Content
                    content={{
                        recommend,
                        newsstream,
                        isEnd,
                        columnId,
                        recommendId,
                        repeatedID,
                    }}
                />
            </main>
            <BottomFooter content={footer} />
            <Chip id="261191" type="struct" title="SEO配置" groupName="页面配置" content={seo}>
                <div className={styles.content_list}>
                    <div className={styles.chip_item} />
                </div>
            </Chip>
            <ChipEdit transform={chipDataTransform} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
